import {
  DocumentTextIcon,
  ClockIcon,
  ChartBarIcon,
  CreditCardIcon,
  CalendarDaysIcon,
  PhotoIcon,
} from "@heroicons/react/24/outline";

export function SideTabs({
  activeTab,
  setActiveTab,
}: {
  activeTab: string;
  setActiveTab: (tab: string) => void;
}) {
  const tabs = [
    {
      id: "details",
      name: "Details",
      Icon: DocumentTextIcon,
      color: "bg-indigo-500",
    },
    {
      id: "hours",
      name: "Hours",
      Icon: ClockIcon,
      color: "bg-emerald-500",
    },
    {
      id: "closed-days",
      name: "Closed Days",
      Icon: CalendarDaysIcon,
      color: "bg-red-500",
    },
    {
      id: "images",
      name: "Images",
      Icon: PhotoIcon,
      color: "bg-fuchsia-500",
    },
    {
      id: "billing",
      name: "Billing",
      Icon: CreditCardIcon,
      color: "bg-blue-500",
    },
    {
      id: "activity",
      name: "Activity",
      Icon: ChartBarIcon,
      color: "bg-amber-500",
    },
  ];

  return (
    <div className="flex gap-1">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => setActiveTab(tab.id)}
          className={`group relative flex items-center gap-2 border-b-2 px-4 py-3 text-sm font-medium transition-all duration-200 ease-in-out ${
            activeTab === tab.id
              ? "border-indigo-500 text-indigo-600"
              : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"
          }`}
        >
          <tab.Icon
            className={`h-5 w-5 flex-shrink-0 transition-colors duration-200 ${
              activeTab === tab.id
                ? "text-indigo-600"
                : "text-gray-400 group-hover:text-gray-500"
            }`}
          />
          <span>{tab.name}</span>
        </button>
      ))}
    </div>
  );
}
